const BuildsPage = () => {
  return (
    <div>
      Builds Overview (In Development)
    </div>
  )
};

export default BuildsPage;
